import Alert from "components/alert";
import Layout from "components/layout";
import Loading from "components/layout/loading";
import Modal from "components/modal";

export default function AuthPage() {
  return (
    <>
      <Layout />
      <Modal />
      <Alert />
      <Loading />
    </>
  );
}
